module.exports = __webpack_public_path__ + "img/impressions_ziran.f5e29fb0.png";